export default __webpack_public_path__ + "static/media/Home Textiles.da5d9c07.jpg";